import { MovieStreamSubtitleMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformSubtitles } from '../../movie-player/transformers/transform-subtitles';

import { useEpisodeOtt } from './use-episode-ott';

export function useSubtitles(contentId: string) {
    const episode = useEpisodeOtt(contentId);

    const subtitles = transformSubtitles(
        (episode?.onlineStreams?.streams?.[0]?.streamMeta
            ?.subtitleMetas as MovieStreamSubtitleMetaFragment[]) || []
    );
    const forceSubtitle = !episode?.onlineStreams?.playerRestrictionConfig?.subtitlesButtonEnable;

    return { subtitles, forceSubtitle };
}
